// Package Imports
import React from 'react';

// Style Imports
import styles from './cartModal.module.scss';
import StylizedButton from "@/components/stylizedButton";

type CheckoutItemsProps = {
  onClose: () => void;
};

const CheckoutModal: React.FC<CheckoutItemsProps> = ({
  onClose,
}) => {
  const handleClick = () => {
    onClose();
    return;
  };

  return (
    <div className={styles.wrapper}>
      <h1 id="dialog_label">We are processing your payment
        <div className={styles.loader}></div>
      </h1>
      <p id="dialog_desc">
        Please don’t refresh the page after submitting payment.<br/>Doing so may result in duplicate charges.
      </p>
      <StylizedButton
        handleClick={handleClick}
        disabled={false}
        size="small"
      >
        Close
      </StylizedButton>
    </div>
  );
};

export default CheckoutModal;
